const $ = require('jquery');

window.$ = $;
window.jQuery = $;

require('bootstrap-sass');
require('jquery.mmenu');
require('animate.css');
require('datatables.net-bs');
var WOW = require('wowjs');

import '/css/kmehr.scss';
import adminMenu from '@elasticms/admin-menu';

const translations = JSON.parse(document.body.getAttribute('data-translations'));
adminMenu('ems_eh_standards', '<i class="ems-icon"></i><span class="sr-only">'+ (translations.back_to_ems === undefined ? 'Back to ems' : translations.back_to_ems) + '</span>');

$(document).ready(function() {

//	var referenceTable;
//
//	// reference table with dataTable plugin
//	if($('#reference-table').length) {
//    	referenceTable = $('#reference-table').DataTable(
//    		{
//    			retrieve: true,
//    			paging: false,
//    			searching: false,
//    			info: false
//    		}
//    	);
//	}

    // swicth lang in reference-table tpl
    var $switchlangSelect = $('#switch-lang-value select');
    if($switchlangSelect.length) {
        $switchlangSelect.on('change', function(){
            $('table [class*="value-"]').addClass('hidden');
            $('.' + this.value ).removeClass('hidden');
            $(this).find('option').not('[value="' + this.value + '"]').removeAttr('selected');
            $('#switch-lang-value option[value="' + this.value + '"]').attr('selected','selected');
        });
    }

});


var $mmenu 			= $('#menu');
var $header 		= $('#header');
var $mainNav 		= $('#main-nav');
var $search 		= $('#search');
var $secondNav 		= $('#second-nav');
var $mainContent 	= $('#main-content');
var $collapseSm 	= $('.collapse-sm .panel .panel-collapse');
var $searchAnimated = $('#search-animated');
var $filterBox		= $('#filter-box');
var scrollPos 		= 0;
var url 			= window.location.pathname;
var idFromUrl;
var regex;

function responsiveMobile() {
    if($(window).outerWidth() < 768) {
        $("#search-animated").removeClass('hidden-xs');
        $('.search-open').find('.fa').addClass('fa-search').removeClass('fa-times');
        $collapseSm.add($filterBox).collapse('hide');
    } else {
        $("#search-animated").removeClass('hide');
        $collapseSm.add($filterBox).addClass('in').removeAttr('style');
    };
}

function onLoad() {
    responsiveMobile();
}

function fixAnchorsOffset(hash) {
    //console.log(hash);
    if(hash){
//		console.log(hash);
        var postition = $(hash).offset();
        if(postition) {
//			console.log(postition);
            $('html, body').animate({ scrollTop: (postition.top-150) }, 400);
        }
    }
}

$(document).ready(function() {
    // SessionStorage allowed in browser
    if (typeof localStorage != "undefined") {
        $('.alert-close').click(function( e ){
            e.preventDefault();
            localStorage.setItem('alert-' + $(this).parent().parent().data('id'), 'hide');
        });
        $('div.alert').each(function (){
            if ('hide' !== localStorage.getItem('alert-' + $(this).data('id'))) {
                $(this).removeClass('hide');
            }
        });

        // key exists ?
        if (! ("cookie" in localStorage)) {
            $("#eu-cookie").show();
        }
        $(".close-cookie").click(function(e) {
            e.preventDefault();
            localStorage.setItem("cookie", "true");
            $("#eu-cookie").fadeOut("slow");
        });
    }

    $('form :submit').click( function () {
        $(this).prop("disabled", true).closest('form').append($('<input/>', {
            type: 'hidden',
            name: this.name,
            value: this.value
        })).submit();
    });

    // EHPORTAL-266
    $('#search-field, #form_field').focus(function (){
        $(this).toggleClass('placeholder-focus');
    });
    $('#search-field, #form_field').blur(function (){
        $(this).toggleClass('placeholder-focus');
    });

    // animate home services wow.js library
    if ($('.wow').length) {
        new WOW.WOW().init();
    }

    /*Clone main-nav and second-nav in mmenu*/
    $mainNav
        .children('ul')
        .clone()
        .prependTo($mmenu);

    if($secondNav.length){
        $secondNav.children('ul').clone().prependTo('#menu .mm-selected');
        $mmenu.closest('.mm-selected').removeAttr('class');
    }

    $mmenu.find('a[href="#"]').each(function(){
        $(this).replaceWith('<span>' + $(this).html() +'</span>')
    })
    $mmenu.find('.dropdown').each(function(){
        $(this)
            .removeClass('dropdown')
            .find('.caret')
            .remove()
        $(this).find('.dropdown-menu')
            .removeClass('.dropdown-menu');
    });

    /!*Run mmenu plugin*!/
    var $menu = $mmenu.mmenu({
        //options
        offCanvas: {
            position: "right"
        },
        extensions: [
            "fx-menu-slide",
            "multiline",
            "shadow-page",
            "pagedim-black",
            "theme-white"
        ]
    }, {
        //configuration
        offCanvas: {
            pageSelector: "#page"
        }

    });
    var $icon = $("#my-icon");
    var API = $menu.data( "mmenu" );

    $icon.on( "click", function() {
        API.open();
    });

    API.bind( "open:start", function() {
        $('body').addClass('mmenu-open');
    });

    API.bind( "open:finish", function() {
        setTimeout(function() {
            $icon.addClass( "is-active" );
        }, 100);
    });
    API.bind( "close:finish", function() {
        $('body').removeClass('mmenu-open');
        setTimeout(function() {
            $icon.removeClass( "is-active" );
        }, 100);
    });

    onLoad();

    // call tooltip - see bootstrap
    if($('[data-toggle="tooltip"]').length) {
        $('[data-toggle="tooltip"]').on('click', function(e) {
            e.preventDefault();
        })
        $('[data-toggle="tooltip"]').tooltip();
    }

    // Collapse the navbar on scroll
    // Be carefull homepage is different, search is in content

    $('.search-open').on('click', function () {
        $('.search-open').find('.fa').toggleClass('fa-search').toggleClass('fa-times');
        $searchAnimated.toggleClass('hide');
        $(this).attr('aria-expanded', !$searchAnimated.hasClass('hide'));
    });

    // Events behaviour EHPORTAL-269
    // scroll to event if hash in url and after user click on event
    if($('.calendar-page').length && url.indexOf('events/2') > -1) {

        url = url.split('/').slice(-3).join('-');
        // id must be in the format of events-Y-m-j
        regex = new RegExp("[[0-9]+-?]*");

        if (regex.test(url)) {
            // We scroll to the first event under the calendar boxes
            $('html, body').animate({ scrollTop: $('form[name="event_filter_form"]').offset().top - 50 }, 400);
            $('#event-1').attr('tabindex',-1).focus();
        }
    }

    $(window).scroll(function() {

        // Start scrolling and offset top > 50
        if ($('.navbar').offset().top > 50) {
            $('body').addClass('header-collapsed');
            $('.navbar-fixed-top').addClass('nav-collapsed');
            if (!$('body').hasClass('home-page')) {
                $searchAnimated.removeAttr('style').addClass('hide');
            }
        } else { // offset under 50
            $('.navbar-fixed-top').fadeIn();
            $('body').removeClass('header-collapsed');
            $('.navbar-fixed-top').removeClass('nav-collapsed');
            if (!$('body').hasClass('home-page') && $(window).outerWidth() >= 768) {
                $searchAnimated.removeAttr('style').removeClass('hide');
            }
        }

        // show/hide header
        var pointerScrollPos = $(this).scrollTop();
        if (pointerScrollPos > scrollPos && $('.navbar').offset().top > 175) {
            //Scrolling Down : hide the menu
            $('.navbar-fixed-top').fadeOut();
        } else {
            // Scrolling up : show the menu
            $('.navbar-fixed-top').fadeIn();
        }
        // keep the current position
        scrollPos = pointerScrollPos;
        $('.search-open').find('.fa').removeClass('fa-times').addClass('fa-search');

    });

    fixAnchorsOffset(window.location.hash);
    $(document).on('click', 'a:not([data-toggle="collapse"])', function(event){
        var url = $(this).attr('href');

        if (url.indexOf('#') >= 0) {
            var hash = url.substring(url.indexOf("#"));

            fixAnchorsOffset(hash);
        }
    });
});

